import React from "react";
import { graphql } from "gatsby";
import { OilCoversFragment as Props } from "./__generated__/OilCoversFragment";
import AnimatedOilCovers from "./AnimatedOilCovers";
import { Box, Hidden, NoSsr } from "@material-ui/core";

export default function OilCoversSection({ covers, speed }: Props) {
  return (
    <Box height={{ xs: "336px", sm: "280px" }}>
      <NoSsr>
        <Hidden xsDown>
          <AnimatedOilCovers covers={covers} speed={speed} direction="left" />
        </Hidden>
        <Hidden smUp>
          <AnimatedOilCovers
            covers={covers.slice(0, covers.length / 2)}
            speed={speed}
            direction="left"
          />
          <AnimatedOilCovers
            covers={covers.slice(covers.length / 2)}
            speed={speed}
            direction="right"
          />
        </Hidden>
      </NoSsr>
    </Box>
  );
}

export const OilCoverFragment = graphql`
  fragment OilCoversFragment on DatoCmsCModuleOilCoversSection {
    covers {
      priceLabel
      oilType
      textColor
      image {
        url
      }
    }
    speed
    container
    containerDisableGutters
    model {
      apiKey
    }
  }
`;
